import { reviews } from '@/mocks/data';

export default function ReaderReview() {
  return (
    <section className="w-full py-14 md:py-20 bg-foreground-950">
      <div className="w-full px-6 md:px-10">
        <div className="flex items-center gap-3 mb-8 md:mb-10">
          <span className="w-1 h-6 md:h-8 bg-accent-500 rounded-full"></span>
          <h2 className="font-heading text-xl md:text-2xl text-white">
            读者<strong className="text-accent-400">评价</strong>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
          {reviews.map((review) => (
            <div key={review.id} className="bg-foreground-900 rounded-lg p-5 md:p-6 relative group">
              <div className="absolute top-0 right-0 text-8xl text-white/5 font-heading leading-none select-none">
                "
              </div>
              <div className="relative z-10">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-full bg-primary-500/20 flex items-center justify-center text-primary-400 font-medium text-sm">
                    {review.avatar}
                  </div>
                  <div>
                    <div className="text-sm font-medium text-background-100">{review.name}</div>
                    <div className="flex items-center gap-0.5 mt-0.5">
                      {Array.from({ length: review.rating }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-[10px] text-accent-500"></i>
                      ))}
                    </div>
                  </div>
                </div>
                <p className="text-sm text-background-200 leading-relaxed">
                  {review.content}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}